import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Flex} from '../Flex';
import {Icon} from '../Icon';
import {Text} from '../Text';
import {Link} from '../Link';
import styles from './Breadcrumbs.scss';
import * as locales from './locales';

export type Breadcrumb = {
  label: string;
  path: string;
};

export interface BreadcrumbProps {
  breadcrumbs: Breadcrumb[];
}

export function BreadcrumbsComponent({breadcrumbs, i18n}: BreadcrumbProps & WithI18nProps) {
  const lastIndex = breadcrumbs.length - 1;
  const backLinkIndex = breadcrumbs.length - 2;

  return (
    <Flex
      role="navigation"
      aria-label={i18n.translate('breadcrumb')}
      wrapperComponent="ul"
      className={styles.list}
    >
      {breadcrumbs.map((breadcrumb, index) => (
        <Flex
          wrapperComponent="li"
          className={classNames(styles.item, index === backLinkIndex && styles.backItem)}
          alignItems="center"
          key={breadcrumb.label}
        >
          {index === lastIndex ? (
            <Text
              text={breadcrumb.label}
              type="small"
              resetMargin
              className={classNames(styles.label, styles.span)}
              ellipsis
            />
          ) : (
            <Link
              className={classNames(styles.label, styles.link)}
              type="small"
              secondary
              resetMargin
              text={breadcrumb.label}
              url={breadcrumb.path}
            />
          )}
          <Icon
            icon="chevronRight"
            fill="grey"
            className={classNames(styles.chevron, styles.forwardChevron)}
          />
        </Flex>
      ))}
    </Flex>
  );
}

export const Breadcrumbs = withI18n({
  id: 'Breadcrumbs',
  fallback: locales.en,
})(BreadcrumbsComponent);
